/*
 * @Descripttion: 
 * @version: 
 * @Author: leon
 * @email: leon0023@zoho.com.cn
 * @Date: 2022-09-20 14:52:08
 * @LastEditors: K
 * @LastEditTime: 2022-09-22 17:03:46
 */

import { Form, Row, Col, Radio, Checkbox, Button } from 'antd';
import React, { ReactElement, useEffect, useState } from 'react';
import { PayMethods, getPayMethodName } from '../../../../models/payment';
import { Checks } from '../../../../models/setting';
import styles from '../TenantSetting.module.css'

interface SettlementProps {
  formObj: any
  formChange: () => void
  onSave: (obj: any) => void
}

export const Settlement = ({
  formObj,
  formChange,
  onSave
}: SettlementProps): ReactElement => {
  const [form] = Form.useForm()


  useEffect(() => {
    if (!formObj) return
    form.setFieldsValue({
      ...formObj,
    })
  }, [formObj])
  return (
    <div style={{ padding: '0 10px' }}>
      <Form
        form={form}
        autoComplete='off'
        onFinish={(values) => {
          onSave(values)
        }}
        onValuesChange={() => formChange()}
      >
        <Row>
          <Col style={{ marginLeft: '50px' }}>
            <Form.Item label='默认支付方式' name={Checks.Mrzffs}>
              <Radio.Group
              // onChange={(e) => {
              //   // setPreviewPayMethod(parseInt(e.target.value))
              //   // if (e.target.value === `${PayMethod.Juhe}`) {
              //   //   notification.warn({
              //   //     message: '您尚未开通聚合支付，请联系客服。',
              //   //   })
              //   //   form.setFieldsValue({
              //   //     [Checks.Mrzffs]: `${previewPayMethod}`,
              //   //   })
              //   // } else {
              //   //   setPreviewPayMethod(parseInt(e.target.value))
              //   // }
              // }}
              >
                {PayMethods.map((p) => (
                  <Radio key={p} value={`${p}`}>
                    {getPayMethodName(p)}
                  </Radio>
                ))}
              </Radio.Group>
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col style={{ marginLeft: '50px' }}>
            <Form.Item
              label='欠费'
              name={Checks.QF}
              valuePropName='checked'
            >
              <Checkbox>启用</Checkbox>
            </Form.Item>
          </Col>
        </Row>
      </Form>
      <div className={styles.btnWrap}>
        <Button onClick={form.submit} type='primary'>
          确认
        </Button>
      </div>
    </div>
  );
}